import { urlForImage } from 'shared-functions'
import Image from 'next/image'

import s from './ImageBox.module.sass'

export default function ImageBox({
    image,
    width = 3500,
    height = 2000,
    loading = 'lazy',
    priority = false,
    blur = true,
    alt,
}: {
    image: any
    width?: number
    height?: number
    loading?: 'lazy' | 'eager'
    mobileAspectRatio?: string
    priority?: boolean
    blur?: boolean
    alt?: string
}) {
    const altText = alt ? alt : image ? (image.alt ? image.alt : '') : ''
    const imageUrl = image?.asset?.url ? image?.asset?.url : urlForImage(image)?.url()
    const blurImage = image?.asset?.metadata?.lqip ? image?.asset?.metadata?.lqip : null

    if (!image) return null

    return (
        <div className={s.Image}>
            <Image
                alt={altText}
                width={width}
                height={height}
                src={imageUrl ? imageUrl : ''}
                placeholder={blurImage && blur ? 'blur' : 'empty'}
                blurDataURL={blurImage && blur ? blurImage : null}
                priority={priority}
                loading={priority ? 'eager' : loading}
            />
        </div>
    )
}
